export enum OrderEntryMode {
  Build = 'Build',
  Review = 'Review',
}

export interface OrderEntryTableMeta {
  areSubstitutionsEnabled: boolean;
  isPriceEditingEnabled: boolean;
}
